import { render, staticRenderFns } from "./BadgeColumn.vue?vue&type=template&id=34055e9f&scoped=true"
import script from "./BadgeColumn.vue?vue&type=script&lang=js"
export * from "./BadgeColumn.vue?vue&type=script&lang=js"
import style0 from "./BadgeColumn.vue?vue&type=style&index=0&id=34055e9f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34055e9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34055e9f')) {
      api.createRecord('34055e9f', component.options)
    } else {
      api.reload('34055e9f', component.options)
    }
    module.hot.accept("./BadgeColumn.vue?vue&type=template&id=34055e9f&scoped=true", function () {
      api.rerender('34055e9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/BadgeColumn.vue"
export default component.exports